module.exports = __webpack_public_path__ + "static/img/link.41a1131b.svg";